export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["इलेक्ट्रॉनिक चेक सक्रियता"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्रेडिट खाता"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["संख्या"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["श्रृंखला"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रियता कोड"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जांचें"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रिय करें"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["इलेक्ट्रॉनिक चेक सक्रिय करें"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["राशि"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्थिति"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रिय"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रिय किया गया"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रद्द"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रिय हो रहा है"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["वापसी"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["लंबित"])}
  }
}